@if (printerFormService.printerFormReady() && printer) {
    <form autocomplete="off" [formGroup]="printerGroupForm" class="tw-contents">
        @if(printer.type === 'nonfiscal') {
            <div class="tw-flex tw-flex-col tw-gap-4 tw-h-full">
                <app-card 
                    [fullWidth]="false"
                    [fullHeigth]="false"
                    [withCard]="true"
                    [cardTitle]="'PRINTERS.DETAIL.OPERATIONS' | translate"
                >
                    <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-p-1 tw-items-center">
                        <div class="tw-col-span-12 md:tw-col-span-8">
                            <app-action-btn variant="stroked" type="secondary"
                                (click)="copyPrinterSettings()">
                                {{'PRINTERS.DETAIL.COPY_PRINTER_SETTINGS' | translate}}
                            </app-action-btn>
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-4">
                            <mat-slide-toggle [formControl]="printerFormService.enableBuzzer!" class="tw-flex tw-py-3 tw-px-1">
                                <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.ENABLE_BUZZER' | translate }}</span>
                            </mat-slide-toggle>
                        </div>
                    </section>
                </app-card>

                <ng-container *ngTemplateOutlet="connectionCard; context: { printer: printer }">
                </ng-container>
            </div>
        } @else {
            <ng-container *ngTemplateOutlet="connectionCard; context: { printer: printer }">
            </ng-container>
        }

        @if(printer.type === 'fiscal' || printer.type === 'rt' || printer.type === 'receipt') {
            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.DOCUMENTS' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 tw-gap-3" [formGroupName]="'settingsForm'">
                    @for(doc of availableDocs; track doc.id; let i = $index) {
                        <!-- <mat-checkbox [formControlName]="doc.check" class="tw-p-1">
                            <span>{{ doc.name }}</span>
                        </mat-checkbox> -->

                        <mat-slide-toggle [formControlName]="doc.check" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ doc.name }}</span>
                        </mat-slide-toggle>
                    }
                </section>
            </app-card>
        }

        @if(printer.type === 'fiscal' || printer.type === 'rt'  || printer.type === 'receipt') {
            
            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.OPTIONS' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-p-1">
                    @if(printer.type === 'fiscal' || printer.type === 'rt') {
                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                            <mat-label translate>PRINTERS.DETAIL.PRINTER_NUMBER</mat-label>
                            <input matInput type="number" [formControl]="printerFormService.printerNumber!"
                                [min]="1">
                            @if(printerFormService.printerNumber?.hasError('max')) {
                                <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (max. {{printerFormService.validators.printerNumberMaxValue}})</mat-error>
                            } @else if(printerFormService.printerNumber?.hasError('min')) {
                                <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (min. {{printerFormService.validators.printerNumberMinValue}})</mat-error>
                            }
                        </mat-form-field>
                    }
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.COLUMNS</mat-label>
                        <input matInput type="number" [formControl]="printerFormService.columns!"
                            [min]="1">
                        @if(printerFormService.columns?.hasError('max')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (max. {{printerFormService.validators.columnsMaxValue}})</mat-error>
                        } @else if(printerFormService.columns?.hasError('min')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (min. {{printerFormService.validators.columnsMinValue}})</mat-error>
                        }
                    </mat-form-field>
                    @if(printer.type === 'receipt') {
                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                            <mat-label translate>PRINTERS.DETAIL.LINE_SPACING</mat-label>
                            <mat-select [formControl]="printerFormService.lineSpacing!">
                                @for(line of lineSpacingList; track line.value) {
                                    <mat-option [value]="line.value">{{line.label | translate}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="tw-col-span-12">
                            <mat-label translate>PRINTERS.DETAIL.PROGRESSIVE_PREFIX</mat-label>
                            <input matInput [formControl]="printerFormService.progressivePrefix!" appTrimInput>
                        </mat-form-field>
                    }
                </section>
            </app-card>
    
            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.CONFIGURATION' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-px-1">
                    <div class="tw-col-span-12 tw-p-2 tw-flex tw-items-center">
                        <mat-slide-toggle [formControl]="printerFormService.configurationPending!">
                            <span class="tw-flex tw-ml-2">{{'PRINTERS.DETAIL.CONFIG_AT_CLOSING' | translate}}</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="tw-col-span-12 lg:tw-col-span-6 tw-px-2 tw-flex tw-items-center">
                        <span [class]="linearLabelClass" translate>
                            PRINTERS.DETAIL.CONFIGURED_AT
                        </span>
                        &nbsp;
                        <span [class]="linearValueClass">
                            {{ printer.configured_at? (printer.configured_at | tilbyDate) : '-' }}
                        </span>
                    </div>
                </section>
            </app-card>
        }

        @if(printer.type === 'nonfiscal') {
            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.DESIGN' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-p-1 tw-items-center">
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.COLUMNS</mat-label>
                        <input matInput type="number" [formControl]="printerFormService.columns!"
                            [min]="1">
                        @if(printerFormService.columns?.hasError('max')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (max. {{printerFormService.validators.columnsMaxValue}})</mat-error>
                        } @else if(printerFormService.columns?.hasError('min')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (min. {{printerFormService.validators.columnsMinValue}})</mat-error>
                        }
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.LINE_SPACING</mat-label>
                        <mat-select [formControl]="printerFormService.lineSpacing!">
                            @for(line of lineSpacingList; track line.value) {
                                <mat-option [value]="line.value">{{line.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TOP_SPACE</mat-label>
                        <input matInput type="number" [formControl]="printerFormService.topSpace!"
                            [min]="1">
                        @if(printerFormService.topSpace?.hasError('max')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (max. {{printerFormService.validators.topSpaceMaxValue}})</mat-error>
                        } @else if(printerFormService.topSpace?.hasError('min')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (min. {{printerFormService.validators.topSpaceMinValue}})</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.BOTTOM_SPACE</mat-label>
                        <input matInput type="number" [formControl]="printerFormService.bottomSpace!"
                            [min]="1">
                        @if(printerFormService.bottomSpace?.hasError('max')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (max. {{printerFormService.validators.bottomSpaceMaxValue}})</mat-error>
                        } @else if(printerFormService.bottomSpace?.hasError('min')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}} (min. {{printerFormService.validators.bottomSpaceMinValue}})</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ITEM_SPACING</mat-label>
                        <mat-select [formControl]="printerFormService.itemSpacing!">
                            @for(space of itemSpacingsList; track space.value) {
                                <mat-option [value]="space.value">{{space.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ITEMS_ALIGN</mat-label>
                        <mat-select [formControl]="printerFormService.itemsAlign!">
                            @for(align of itemsAlignsList; track align.value) {
                                <mat-option [value]="align.value">{{align.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <div class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-slide-toggle [formControl]="printerFormService.itemHideBorder!" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.HIDE_BORDER' | translate }}</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-slide-toggle [formControl]="printerFormService.itemHideBrackets!" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.HIDE_BRACKETS' | translate }}</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-slide-toggle [formControl]="printerFormService.splitOrdersByExit!" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.SPLIT_ORDERS_BY_EXIT' | translate }}</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-slide-toggle [formControl]="printerFormService.addPricesToOrder!" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.ADD_PRICES_TO_ORDER' | translate }}</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-slide-toggle [formControl]="printerFormService.mergeSameItems!" class="tw-flex tw-p-3">
                            <span class="tw-flex tw-ml-2">{{ 'PRINTERS.DETAIL.MERGE_SAME_ITEMS' | translate }}</span>
                        </mat-slide-toggle>
                    </div>
                </section>
            </app-card>

            <app-card 
                [fullWidth]="true"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.ITEMS_LIST' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-p-1 tw-items-center">
                    <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                        <mat-label translate>PRINTERS.DETAIL.ITEM</mat-label>
                        <mat-select [formControl]="printerFormService.itemFontSize!">
                            @for(size of fontSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                        <mat-label translate>PRINTERS.DETAIL.VARIATIONS</mat-label>
                        <mat-select [formControl]="printerFormService.variationFontSize!">
                            @for(size of fontSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                        <mat-label translate>PRINTERS.DETAIL.OTHER_PRINTERS</mat-label>
                        <mat-select [formControl]="printerFormService.otherPrintersFontSize!">
                            @for(size of fontSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-3">
                        <mat-label translate>PRINTERS.DETAIL.ITEMS_GROUP_BY</mat-label>
                        <mat-select [formControl]="printerFormService.itemsGroupBy!">
                            @for(size of itemsGroupByList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </section>
            </app-card>

            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.HEADER' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-p-1 tw-items-center">
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_CATEGORIES</mat-label>
                        <mat-select [formControl]="printerFormService.headerOrderCategories!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_NUMBER</mat-label>
                        <mat-select [formControl]="printerFormService.headerOrderNumber!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.OPERATOR_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.headerOperatorName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.DATE</mat-label>
                        <mat-select [formControl]="printerFormService.headerDate!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TIME</mat-label>
                        <mat-select [formControl]="printerFormService.headerTime!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_PRINT_TYPE</mat-label>
                        <mat-select [formControl]="printerFormService.headerPrintType!">
                            @for(size of fontSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ROOM_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.headerRoomName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TABLE_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.headerTableName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.COVERS</mat-label>
                        <mat-select [formControl]="printerFormService.headerCovers!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.DELIVERY_INFO</mat-label>
                        <mat-select [formControl]="printerFormService.headerDeliveryInfo!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.headerOrderName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.CUSTOMER_INFO</mat-label>
                        <mat-select [formControl]="printerFormService.headerCustomerInfo!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_NOTES</mat-label>
                        <mat-select [formControl]="printerFormService.headerOrderNotes!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TOTAL_PIECES</mat-label>
                        <mat-select [formControl]="printerFormService.headerTotalPieces!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.FINAL_AMOUNT</mat-label>
                        <mat-select [formControl]="printerFormService.headerFinalAmount!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </section>
            </app-card>


            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.DETAIL.FOOTER' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-p-1 tw-items-center">
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_CATEGORIES</mat-label>
                        <mat-select [formControl]="printerFormService.footerOrderCategories!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_NUMBER</mat-label>
                        <mat-select [formControl]="printerFormService.footerOrderNumber!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.OPERATOR_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.footerOperatorName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.DATE</mat-label>
                        <mat-select [formControl]="printerFormService.footerDate!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TIME</mat-label>
                        <mat-select [formControl]="printerFormService.footerTime!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_PRINT_TYPE</mat-label>
                        <mat-select [formControl]="printerFormService.footerPrintType!">
                            @for(size of fontSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ROOM_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.footerRoomName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TABLE_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.footerTableName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.COVERS</mat-label>
                        <mat-select [formControl]="printerFormService.footerCovers!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.DELIVERY_INFO</mat-label>
                        <mat-select [formControl]="printerFormService.footerDeliveryInfo!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_NAME</mat-label>
                        <mat-select [formControl]="printerFormService.footerOrderName!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.CUSTOMER_INFO</mat-label>
                        <mat-select [formControl]="printerFormService.footerCustomerInfo!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.ORDER_NOTES</mat-label>
                        <mat-select [formControl]="printerFormService.footerOrderNotes!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.TOTAL_PIECES</mat-label>
                        <mat-select [formControl]="printerFormService.footerTotalPieces!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="tw-col-span-12 lg:tw-col-span-6">
                        <mat-label translate>PRINTERS.DETAIL.FINAL_AMOUNT</mat-label>
                        <mat-select [formControl]="printerFormService.footerFinalAmount!">
                            @for(size of headerSizeList; track size.value) {
                                <mat-option [value]="size.value">{{size.label | translate}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </section>
            </app-card>
        }
    </form>
}

<ng-template #connectionCard let-printer="printer" let-config="config">
    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.CONNECTION' | translate"
    >
        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-p-1 tw-items-center">
    
            <mat-form-field class="tw-col-span-12">
                <mat-label translate>PRINTERS.DETAIL.NAME</mat-label>
                <input matInput [formControl]="printerFormService.printerName!" appTrimInput>
                <mat-hint [align]="'end'">{{printerFormService.printerName?.value?.length || '0'}}
                    / {{printerFormService.validators.nameMaxLength}}</mat-hint>
                @if(printerFormService.printerName?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{printerFormService.validators.nameMaxLength}})</mat-error>
                } @else if(printerFormService.printerName?.hasError('minlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_SHORT' | translate}} (max. {{printerFormService.validators.nameMinLength}})</mat-error>
                } @else if(printerFormService.printerName?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>

            <mat-form-field class="tw-col-span-12">
                <mat-label translate>PRINTERS.DETAIL.IP</mat-label>
                <input matInput [formControl]="printerFormService.ipAddress!" appTrimInput>
                <mat-hint [align]="'end'">{{printerFormService.ipAddress?.value?.length || '0'}}
                    / {{printerFormService.validators.ipAddressMaxLength}}</mat-hint>
                @if(printerFormService.ipAddress?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{printerFormService.validators.ipAddressMaxLength}})</mat-error>
                }
            </mat-form-field>

            @if(printer.type === 'nonfiscal' || printer.type === 'receipt') {
                <mat-form-field class="tw-col-span-12">
                    <mat-label translate>PRINTERS.DETAIL.DRIVE</mat-label>
                    <mat-select [formControl]="printerFormService.driver!">
                        @for(driver of printerDriverList; track driver.value) {
                            <mat-option [value]="driver.value">{{driver.label | translate}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            @if(printer.driver === 'escpos') {
                <mat-form-field class="tw-col-span-12">
                    <mat-label translate>PRINTERS.DETAIL.CODEPAGE_MAPPING</mat-label>
                    <mat-select [formControl]="printerFormService.codepageMapping!">
                        @for(code of codepageMappings; track code.value) {
                            <mat-option [value]="code.value">{{code.name}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            @if(printer.type !== 'nonfiscal' && printer.type !== 'receipt') {
                <div class="tw-col-span-12 lg:tw-col-span-6 tw-px-2 tw-flex tw-flex-col">
                    <span [class]="priceLabelClass" translate>
                        PRINTERS.DETAIL.DRIVE
                    </span>
                    <span [class]="priceValueClass">
                        {{ printer.driver || '-' }}
                    </span>
                </div>
            }

            @if(printer.type === 'receipt') {
                <div class="tw-col-span-12 lg:tw-col-span-6 tw-px-2 tw-flex tw-flex-col">
                    <span [class]="priceLabelClass" translate>
                        PRINTERS.DETAIL.FISCAL_PROVIDER
                    </span>
                    <span [class]="priceValueClass">
                        {{ printer.fiscal_provider || '-' }}
                    </span>
                </div>
            }

            @if(printer.driver === 'epson') {
                <div class="tw-col-span-12 lg:tw-col-span-6 tw-p-2 tw-flex tw-items-center">
                    <mat-slide-toggle [formControl]="printerFormService.ssl!">
                        <span class="tw-flex tw-ml-2">{{'PRINTERS.DETAIL.ENABLE_SSL' | translate}}</span>
                    </mat-slide-toggle>
                </div>
            }

        </section>
    </app-card>
</ng-template>